import LogoutService from "@/services/LogoutService";

export default {
    mutations: {
        clearAuthData() {
            localStorage.removeItem("authToken");
        },
    },

    actions: {
        async logout({ commit, dispatch }, payload) {
            try {
                const response = await LogoutService.logout(payload.userToken);

                dispatch('resetUserDataUserModule')
                Object.keys(sessionStorage)
                    .filter((key) => key.startsWith('materialsDisciplineEditMode:'))
                    .forEach((key) => sessionStorage.removeItem(key))

                return response.data;
            } catch (error) {
                console.error(error)
            }
        }
    }
}
